import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import logo from '../assets/logo.png';
import './Welcome.css';

const Welcome = () => {
  const { user } = useContext(AuthContext);

  // Agrupar módulos por categoría
  const groupedModules = user?.modules?.reduce((acc, module) => {
    const category = module.category || 'Otros';
    if (!acc[category]) acc[category] = [];
    acc[category].push(module);
    return acc;
  }, {}) || {};

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Navbar title={`👋 ¡Hola, ${user?.username}!`} />

        <div className="page-content welcome-page">
          <div className="welcome-card">
            <div className="welcome-header">
              <img src={logo} alt="TRANSIAPP" className="welcome-logo" />
              <h2>Bienvenido a TRANSIAPP</h2>
              <p>No tienes acceso al Dashboard principal, pero aquí tienes tus opciones disponibles:</p>
            </div>

            <div className="available-options">
              {Object.entries(groupedModules).map(([category, modules]) => (
                <div key={category} className="welcome-category-section">
                  <h3>{category}</h3>
                  <div className="options-grid">
                    {modules.map((module) => (
                      <Link key={module.id} to={module.path} className="option-card">
                        <span className="option-icon">{module.icon}</span>
                        <div className="option-info">
                          <span className="option-label">{module.label}</span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {user?.modules?.length === 0 && (
              <div className="no-modules-alert">
                <p>⚠️ No tienes módulos asignados. Contacta al administrador para obtener acceso.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
